module.exports = __webpack_public_path__ + "media/images/icons/twotone/check-circle-187cdda8f6e5fc6d7b1861f004ba0ce7.svg";